import styles from './TabBar.module.css';
const T=[{l:'TV Shows',i:'📺'},{l:'Commercials',i:'📢'}];
export default function TabBar({active,onChange}) {
  return (<div className={styles.bar}>
    {T.map((t,i)=>(
      <button key={i} className={`${styles.tab}${active===i?" "+styles.on:""}`} onClick={()=>onChange(i)}>
        {t.i} {t.l}
      </button>
    ))}
  </div>);
}